import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "editor"]

  connect() {
    this.configureTrixLists()
    this.moveButtonToHeader()
    this.checkContent()

  }

  disconnect() {
    // Move button back when form is destroyed
    const headerContainer = document.getElementById('note_form_button')
    if (headerContainer) {
      headerContainer.innerHTML = ''
    }
  }

  moveButtonToHeader() {
    const headerContainer = document.getElementById('note_form_button')
    if (headerContainer && this.submitButtonTarget) {
      // Clone the button and move it to header
      const buttonClone = this.submitButtonTarget.cloneNode(true)
      buttonClone.style.display = 'flex'
      
      // Ensure proper button styling is maintained
      buttonClone.className = 'btn btn-primary gap-2'
      buttonClone.style.alignItems = 'center'
      buttonClone.style.justifyContent = 'center'
      
      // Replace the original button with the clone functionality
      this.submitButtonTarget.style.display = 'none'
      
      // When clone is clicked, trigger the original button
      buttonClone.addEventListener('click', (e) => {
        e.preventDefault()
        this.submitButtonTarget.click()
      })
      
      headerContainer.innerHTML = ''
      headerContainer.appendChild(buttonClone)
      
      // Update target to point to the clone for enabling/disabling
      this.clonedButton = buttonClone
    }
  }

  checkContent() {
    const trixEditor = this.editorTarget
    const hasContent = trixEditor.value && trixEditor.value.trim().length > 0
    
    if (this.clonedButton) {
      this.clonedButton.disabled = !hasContent
    }
    this.submitButtonTarget.disabled = !hasContent
  }

  configureTrixLists() {
    // Configure Trix block attributes for lists
    if (typeof Trix !== 'undefined') {
      // Configure bullet list
      Trix.config.blockAttributes.bulletList = {
        tagName: "ul",
        parse: false,
        exclusive: false
      }
      
      // Configure numbered list  
      Trix.config.blockAttributes.numberList = {
        tagName: "ol", 
        parse: false,
        exclusive: false
      }
      
      // Configure list item
      Trix.config.blockAttributes.listItem = {
        tagName: "li",
        listAttribute: "bulletList",
        parse: false,
        exclusive: false
      }
      
      // Configure numbered list item
      Trix.config.blockAttributes.numberListItem = {
        tagName: "li",
        listAttribute: "numberList", 
        parse: false,
        exclusive: false
      }
    }
  }


} 